import { SubmitButton } from '../Form/SubmitButton/SubmitButton';
import { Form } from '../Form/Form';
import { Input } from '../Form/Input/Input';
import { Select } from '../Form/Select/Select';

import type { UserResponse, UserRole } from '../../types';

import styles from './UserForm.module.scss';

const roles: { label: string; value: UserRole }[] = [
  { label: 'Admin', value: 'admin' },
  { label: 'Journalist', value: 'journalist' },
];

type Props = {
  user: UserResponse;
  onSubmit: (values: UserResponse) => Promise<void>;
};

function UserForm({ user, onSubmit }: Props) {
  const isNew = user.id === undefined;

  return (
    <Form initialValues={user} onSubmit={onSubmit}>
      <Input label="First name" name="firstName" />
      <Input label="Last name" name="lastName" />
      <Input label="Email" name="email" disabled={!isNew} />
      {<Select label="Role" name="role" options={roles} disabled={isNew} />}
      <div className={styles.buttons}>
        <SubmitButton>{isNew ? 'Create user' : 'Save'}</SubmitButton>
      </div>
    </Form>
  );
}

export { UserForm };
